// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&family=Syne:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --bg:      #f8f9fc;
  --bg2:     #ffffff;
  --bg3:     #f1f3f8;
  --bg4:     #e8ecf4;
  --border:  #e2e6ef;
  --border2: #cbd2e0;
  --text:    #111827;
  --text2:   #374151;
  --text3:   #6b7280;
  --accent:  #4f46e5;
  --accent2: #4338ca;
  --accent-glow: rgba(79, 70, 229, 0.2);
  --green:   #059669;
  --red:     #dc2626;
  --amber:   #d97706;
  --radius:    10px;
  --radius-lg: 14px;
}

html, body, #root { height: 100%; }

body {
  font-family: 'Syne', sans-serif;
  background: var(--bg);
  color: var(--text);
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

/* ── App shell (top nav + full width) ─────────── */
.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden;
}

.app-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background: var(--bg);
}

/* ── Top navigation ───────────────────────────── */
.topnav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 24px;
  background: var(--bg2);
  border-bottom: 1px solid var(--border);
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.topnav-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 700;
  font-size: 17px;
  letter-spacing: -0.35px;
  color: var(--text);
}

.topnav-brand-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.12), rgba(79, 70, 229, 0.06));
  border: 1px solid rgba(79, 70, 229, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
}

.topnav-nav {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  justify-content: center;
  flex-wrap: wrap;
  min-width: 0;
}

.nav-link {
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--radius);
  padding: 8px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: var(--text2);
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.nav-link:hover {
  background: var(--bg3);
  color: var(--text);
}

.nav-link-active {
  background: rgba(79, 70, 229, 0.1);
  border-color: rgba(79, 70, 229, 0.25);
  color: var(--accent);
}

.topnav-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.session-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  font-size: 12px;
  font-weight: 600;
  color: var(--text2);
  background: var(--bg3);
  border-radius: var(--radius);
  border: 1px solid var(--border);
}

.session-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--green);
}

/* ── Main content (full width) ─────────────────── */
.main-content {
  flex: 1 1;
  overflow-y: auto;
  background: var(--bg);
}

.page {
  padding: 24px 32px 48px;
  width: 100%;
  max-width: none;
}

.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.page-header h2 {
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.6px;
  color: var(--text);
}

.page-sub {
  color: var(--text3);
  font-size: 13px;
  margin-top: 6px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

/* ── Buttons ───────────────────────────────────── */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: var(--radius);
  border: none;
  font-family: 'Syne', sans-serif;
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.18s ease, background 0.18s ease, border-color 0.18s ease;
  white-space: nowrap;
}
.btn:active:not(:disabled) { transform: scale(0.98); }
.btn:disabled { opacity: 0.45; cursor: not-allowed; }

.btn-primary {
  background: linear-gradient(135deg, var(--accent), var(--accent2));
  color: #fff;
  box-shadow: 0 2px 12px var(--accent-glow);
}
.btn-primary:hover:not(:disabled) {
  box-shadow: 0 4px 16px var(--accent-glow);
  filter: brightness(1.03);
}

.btn-secondary {
  background: var(--bg2);
  color: var(--text2);
  border: 1px solid var(--border2);
}
.btn-secondary:hover:not(:disabled) {
  background: var(--bg3);
  color: var(--text);
  border-color: var(--accent);
}

.btn-danger {
  background: transparent;
  color: var(--red);
  border: 1px solid rgba(220, 38, 38, 0.35);
}
.btn-danger:hover:not(:disabled) {
  background: rgba(220, 38, 38, 0.06);
  border-color: var(--red);
}

.btn-ghost {
  background: transparent;
  color: var(--text2);
  border: 1px solid var(--border);
}
.btn-ghost:hover:not(:disabled) { background: var(--bg3); color: var(--text); }

.btn-full { width: 100%; }
.btn-sm { padding: 7px 14px; font-size: 12.5px; }
.btn-xs { padding: 5px 12px; font-size: 12px; }

/* ── Search ────────────────────────────────────── */
.search-input {
  background: var(--bg2);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--text);
  font-family: 'Syne', sans-serif;
  font-size: 13.5px;
  padding: 9px 14px;
  min-width: 200px;
  flex: 1 1;
  max-width: 320px;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.search-input::placeholder { color: var(--text3); }
.search-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);
}

/* ── DB Cards ──────────────────────────────────── */
.db-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.db-grid-stack {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.db-grid-divider {
  height: 0;
  margin: 20px 0;
  border: none;
  border-top: 1px solid var(--border);
  width: 100%;
}

.db-branch-empty-notice {
  margin: 0 0 20px;
  padding: 14px 18px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--bg3);
  color: var(--text2);
  font-size: 13.5px;
  line-height: 1.5;
}

.db-branch-empty-notice p {
  margin: 0;
}

.db-branch-empty-notice strong {
  font-weight: 700;
  color: var(--text);
}

/* Branch subsection (under protected cards, above droppable grid or empty notice) */
.db-branch-section {
  margin-bottom: 12px;
}

.db-branch-section-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text);
  letter-spacing: -0.2px;
  margin: 0;
}

.db-branch-empty-notice-branch-slot {
  margin-top: 0;
  margin-bottom: 20px;
}

.db-card-glass {
  background: var(--bg2);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 20px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.db-card-glass:hover {
  border-color: rgba(79, 70, 229, 0.35);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.db-card-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.db-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 5px;
}
.db-status-online {
  background: var(--green);
  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.2);
}
.db-status-offline {
  background: var(--text3);
}

.db-name {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12.5px;
  color: var(--text);
  word-break: break-all;
  font-weight: 500;
  line-height: 1.45;
}

.db-detail-line {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: var(--text3);
  margin-top: 4px;
  padding-left: 18px;
  line-height: 1.4;
}

.db-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.db-meta-item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: var(--text3);
  font-size: 12px;
}

.db-state-pill {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 4px 8px;
  border-radius: 6px;
  background: var(--bg3);
  color: var(--text3);
  border: 1px solid var(--border);
}
.db-state-online { background: rgba(5, 150, 105, 0.1); color: var(--green); border-color: rgba(5, 150, 105, 0.25); }
.db-state-unknown { background: rgba(217, 119, 6, 0.1); color: var(--amber); border-color: rgba(217, 119, 6, 0.25); }

.db-actions {
  display: flex;
  gap: 8px;
  margin-top: 6px;
  align-items: center;
  min-height: 32px;
}

.db-no-drop {
  font-size: 11.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: var(--text3);
  padding: 6px 10px;
  border-radius: 6px;
  background: var(--bg3);
  border: 1px solid var(--border);
  cursor: default;
  user-select: none;
}

/* Protected databases strip (config reference + border before main list) */
.protected-section {
  margin-bottom: 28px;
  padding-bottom: 28px;
  border-bottom: 1px solid var(--border);
}

.protected-section h3 {
  font-size: 14px;
  font-weight: 700;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.protected-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.protected-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11.5px;
  padding: 8px 12px;
  background: var(--bg3);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  color: var(--text2);
  cursor: default;
}

.protected-tag svg {
  flex-shrink: 0;
  opacity: 0.65;
}

/* Skeletons */
.db-card-skeleton {
  min-height: 160px;
  background: var(--bg2);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 20px;
}
.skeleton-line {
  background: linear-gradient(90deg, var(--bg3) 25%, var(--bg4) 50%, var(--bg3) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.2s ease-in-out infinite;
  border-radius: 6px;
}
.skeleton-title { height: 16px; width: 70%; margin-bottom: 14px; }
.skeleton-meta { height: 12px; width: 45%; margin-bottom: 20px; }
.skeleton-actions { height: 32px; width: 100%; opacity: 0.5; }
@keyframes shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

/* ── Modal ─────────────────────────────────────── */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.45);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
  padding: 16px;
}

.modal-glass {
  background: var(--bg2);
  border: 1px solid var(--border);
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.12);
}

.modal {
  border-radius: var(--radius-lg);
  padding: 28px;
  width: 440px;
  max-width: 100%;
}

.modal h3 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 8px;
  letter-spacing: -0.3px;
  color: var(--text);
}

.modal-sub {
  color: var(--text3);
  font-size: 13px;
  margin-bottom: 22px;
  line-height: 1.45;
}

.mono-inline {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  color: var(--accent);
}

.modal-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 24px;
}

/* ── Forms ─────────────────────────────────────── */
.field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: 16px;
}

.field label {
  font-size: 11.5px;
  font-weight: 700;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.field input,
.field select {
  background: var(--bg2);
  border: 1px solid var(--border2);
  border-radius: var(--radius);
  color: var(--text);
  font-family: 'Syne', sans-serif;
  font-size: 14px;
  padding: 11px 12px;
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.field input:focus,
.field select:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
}
.field input::placeholder { color: var(--text3); }
.field select option { background: var(--bg2); }

.field-hint {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11.5px;
  color: var(--accent);
}

.field-hint-preview {
  margin-top: 8px;
  font-family: 'Syne', sans-serif;
  font-size: 12px;
  color: var(--text3);
}

.field-hint-preview .mono-inline {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11.5px;
  color: var(--accent);
}

.field-label-block {
  display: block;
  font-size: 11.5px;
  font-weight: 700;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 10px;
}

.radio-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 13px;
  line-height: 1.45;
  color: var(--text2);
}

.radio-row input {
  margin-top: 3px;
  accent-color: var(--accent);
  flex-shrink: 0;
}

.radio-row strong {
  color: var(--text);
}

.field-warning {
  font-size: 12.5px;
  color: var(--amber);
  margin-top: 8px;
  line-height: 1.4;
}

.inline-code {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11.5px;
  background: var(--bg3);
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--accent);
}

/* ── Login (light) ─────────────────────────────── */
.login-page-hangfire {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(165deg, #eef2ff 0%, var(--bg) 45%, #f8fafc 100%);
}

.login-glass {
  border-radius: 20px;
  border: 1px solid var(--border);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);
}

.login-card-hangfire {
  width: 100%;
  max-width: 400px;
  padding: 44px 40px;
  background: var(--bg2);
}

.login-lock-wrap {
  width: 56px;
  height: 56px;
  margin: 0 auto 20px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(79, 70, 229, 0.12), rgba(79, 70, 229, 0.05));
  border: 1px solid rgba(79, 70, 229, 0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--accent);
}

.login-title-hangfire {
  text-align: center;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin-bottom: 8px;
  color: var(--text);
}

.login-sub-hangfire {
  text-align: center;
  color: var(--text3);
  font-size: 14px;
  margin-bottom: 28px;
}

.login-form-hangfire {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.login-password-input {
  width: 100%;
  padding: 14px 16px;
  font-size: 15px;
  font-family: 'Syne', sans-serif;
  border-radius: var(--radius);
  border: 1px solid var(--border2);
  background: var(--bg2);
  color: var(--text);
  outline: none;
  transition: border-color 0.18s, box-shadow 0.18s;
}
.login-password-input:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
}
.login-password-input::placeholder { color: var(--text3); }

.btn-unlock {
  padding: 12px;
  font-size: 14px;
}

.error-msg-compact {
  margin-bottom: 0;
}

.error-msg {
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.25);
  color: var(--red);
  border-radius: var(--radius);
  padding: 10px 12px;
  font-size: 13px;
}

/* ── Empty / loading ───────────────────────────── */
.empty-state-modern {
  padding: 56px 24px;
  border-radius: var(--radius-lg);
  border: 1px dashed var(--border2);
  background: var(--bg2);
}

.empty-icon-wrap {
  width: 72px;
  height: 72px;
  margin: 0 auto 16px;
  border-radius: 16px;
  background: rgba(79, 70, 229, 0.08);
  border: 1px solid rgba(79, 70, 229, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text3);
}

.empty-title {
  font-size: 17px;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 6px;
}

.empty-desc {
  font-size: 13.5px;
  color: var(--text3);
  margin-bottom: 20px;
  max-width: 360px;
  margin-left: auto;
  margin-right: auto;
}

.loading-state,
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  text-align: center;
  color: var(--text3);
}

.spinner {
  width: 30px;
  height: 30px;
  border: 2px solid var(--border);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Toast (top-right) ─────────────────────────── */
.toast {
  position: fixed;
  top: 24px;
  right: 24px;
  bottom: auto;
  left: auto;
  padding: 14px 20px;
  border-radius: var(--radius);
  font-size: 13.5px;
  font-weight: 600;
  z-index: 200;
  animation: toastIn 0.25s ease;
  max-width: min(420px, calc(100vw - 32px));
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
}
.toast-success {
  background: var(--bg2);
  border: 1px solid rgba(5, 150, 105, 0.4);
  color: var(--green);
}
.toast-error {
  background: var(--bg2);
  border: 1px solid rgba(220, 38, 38, 0.35);
  color: var(--red);
}

@keyframes toastIn {
  from { transform: translateY(-10px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

/* ── Logs page ─────────────────────────────────── */
.page-logs .logs-toolbar {
  flex-wrap: wrap;
  gap: 10px;
  align-items: flex-end;
}

.logs-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.logs-field-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--text3);
}

.logs-field input[type="date"],
.logs-field select {
  font-family: inherit;
  font-size: 13px;
  padding: 8px 10px;
  border-radius: var(--radius);
  border: 1px solid var(--border2);
  background: var(--bg2);
  color: var(--text);
}

.logs-checkbox {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  padding-bottom: 4px;
}

.logs-checkbox span {
  font-size: 13px;
  font-weight: 600;
  color: var(--text2);
}

.logs-error {
  margin-bottom: 16px;
  padding: 12px 16px;
  border-radius: var(--radius);
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.25);
  color: var(--red);
  font-size: 13px;
}

.log-viewer {
  background: var(--bg2);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px;
  max-height: min(70vh, 720px);
  overflow: auto;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11.5px;
  line-height: 1.45;
}

.log-line {
  margin: 0 0 6px;
  white-space: pre-wrap;
  word-break: break-word;
  color: var(--text2);
}

.log-line:last-child {
  margin-bottom: 0;
}

.log-level-error {
  color: var(--red);
}

.log-level-warn {
  color: var(--amber);
}

.log-level-info,
.log-level-http {
  color: var(--text2);
}

.logs-loading,
.logs-empty {
  color: var(--text3);
  font-size: 13px;
  padding: 8px 0;
}

/* ── Mobile ───────────────────────────────────── */
@media (max-width: 640px) {
  .topnav {
    padding: 12px 16px;
  }

  .topnav-nav {
    order: 3;
    width: 100%;
    justify-content: flex-start;
  }

  .page {
    padding: 16px 16px 32px;
  }

  .page-header {
    flex-direction: column;
    align-items: stretch;
  }

  .header-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .search-input {
    max-width: none;
    width: 100%;
  }

  .db-grid {
    grid-template-columns: 1fr;
  }

  .toast {
    top: 16px;
    left: 16px;
    right: 16px;
    bottom: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA,yBAAyB,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE;;AAExE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA,oBAAoB,YAAY,EAAE;;AAElC;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,mCAAmC;AACrC;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,qBAAqB;AACvB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;EACtC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qFAAqF;EACrF,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,SAAO;EACP,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,4BAA4B;EAC5B,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,uGAAuG;EACvG,mBAAmB;AACrB;AACA,6BAA6B,sBAAsB,EAAE;AACrD,gBAAgB,aAAa,EAAE,mBAAmB,EAAE;;AAEpD;EACE,kEAAkE;EAClE,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,yCAAyC;AAC3C;AACA;EACE,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;AACA,kCAAkC,sBAAsB,EAAE,kBAAkB,EAAE;;AAE9E,YAAY,WAAW,EAAE;AACzB,UAAU,iBAAiB,EAAE,iBAAiB,EAAE;AAChD,UAAU,iBAAiB,EAAE,eAAe,EAAE;;AAE9C,qDAAqD;AACrD;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,gDAAgD;AAClD;AACA,6BAA6B,mBAAmB,EAAE;AAClD;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,SAAS;EACT,cAAc;EACd,YAAY;EACZ,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oFAAoF;AACpF;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,4CAA4C;EAC5C,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;AACA;EACE,wBAAwB;EACxB,4CAA4C;AAC9C;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,+BAA+B;AACjC;AACA,mBAAmB,kCAAkC,EAAE,mBAAmB,EAAE,qCAAqC,EAAE;AACnH,oBAAoB,kCAAkC,EAAE,mBAAmB,EAAE,qCAAqC,EAAE;;AAEpH;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;AACnB;;AAEA,2EAA2E;AAC3E;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,wCAAwC;EACxC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;AACf;AACA;EACE,kFAAkF;EAClF,0BAA0B;EAC1B,4CAA4C;EAC5C,kBAAkB;AACpB;AACA,kBAAkB,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE;AACjE,iBAAiB,YAAY,EAAE,UAAU,EAAE,mBAAmB,EAAE;AAChE,oBAAoB,YAAY,EAAE,WAAW,EAAE,YAAY,EAAE;AAC7D;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;EACtB,gCAAgC;EAChC,4BAA4B;EAC5B,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gDAAgD;AAClD;AACA;;EAEE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA,4BAA4B,mBAAmB,EAAE;AACjD,uBAAuB,sBAAsB,EAAE;;AAE/C;EACE,wCAAwC;EACxC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4EAA4E;AAC9E;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,qFAAqF;EACrF,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gDAAgD;AAClD;AACA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;AACA,qCAAqC,mBAAmB,EAAE;;AAE1D;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,qCAAqC;AACvC;AACA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD,qDAAqD;AACrD;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,yCAAyC;EACzC,6CAA6C;AAC/C;AACA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,OAAO,4BAA4B,EAAE,UAAU,EAAE;EACjD,KAAK,wBAAwB,EAAE,UAAU,EAAE;AAC7C;;AAEA,qDAAqD;AACrD;EACE,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,mCAAmC;EACnC,yCAAyC;EACzC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;EAC5B,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=JetBrains+Mono:wght@400;500&family=Syne:wght@400;500;600;700&display=swap');\n\n*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }\n\n:root {\n  --bg:      #f8f9fc;\n  --bg2:     #ffffff;\n  --bg3:     #f1f3f8;\n  --bg4:     #e8ecf4;\n  --border:  #e2e6ef;\n  --border2: #cbd2e0;\n  --text:    #111827;\n  --text2:   #374151;\n  --text3:   #6b7280;\n  --accent:  #4f46e5;\n  --accent2: #4338ca;\n  --accent-glow: rgba(79, 70, 229, 0.2);\n  --green:   #059669;\n  --red:     #dc2626;\n  --amber:   #d97706;\n  --radius:    10px;\n  --radius-lg: 14px;\n}\n\nhtml, body, #root { height: 100%; }\n\nbody {\n  font-family: 'Syne', sans-serif;\n  background: var(--bg);\n  color: var(--text);\n  font-size: 14px;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* ── App shell (top nav + full width) ─────────── */\n.app {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  overflow: hidden;\n}\n\n.app-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background: var(--bg);\n}\n\n/* ── Top navigation ───────────────────────────── */\n.topnav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 12px;\n  padding: 14px 24px;\n  background: var(--bg2);\n  border-bottom: 1px solid var(--border);\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.topnav-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-weight: 700;\n  font-size: 17px;\n  letter-spacing: -0.35px;\n  color: var(--text);\n}\n\n.topnav-brand-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.12), rgba(79, 70, 229, 0.06));\n  border: 1px solid rgba(79, 70, 229, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent);\n}\n\n.topnav-nav {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  justify-content: center;\n  flex-wrap: wrap;\n  min-width: 0;\n}\n\n.nav-link {\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: var(--radius);\n  padding: 8px 14px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text2);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s, border-color 0.15s;\n}\n\n.nav-link:hover {\n  background: var(--bg3);\n  color: var(--text);\n}\n\n.nav-link-active {\n  background: rgba(79, 70, 229, 0.1);\n  border-color: rgba(79, 70, 229, 0.25);\n  color: var(--accent);\n}\n\n.topnav-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.session-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text2);\n  background: var(--bg3);\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n}\n\n.session-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--green);\n}\n\n/* ── Main content (full width) ─────────────────── */\n.main-content {\n  flex: 1;\n  overflow-y: auto;\n  background: var(--bg);\n}\n\n.page {\n  padding: 24px 32px 48px;\n  width: 100%;\n  max-width: none;\n}\n\n.page-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.page-header h2 {\n  font-size: 24px;\n  font-weight: 700;\n  letter-spacing: -0.6px;\n  color: var(--text);\n}\n\n.page-sub {\n  color: var(--text3);\n  font-size: 13px;\n  margin-top: 6px;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n/* ── Buttons ───────────────────────────────────── */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 9px 18px;\n  border-radius: var(--radius);\n  border: none;\n  font-family: 'Syne', sans-serif;\n  font-size: 13.5px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: transform 0.12s ease, box-shadow 0.18s ease, background 0.18s ease, border-color 0.18s ease;\n  white-space: nowrap;\n}\n.btn:active:not(:disabled) { transform: scale(0.98); }\n.btn:disabled { opacity: 0.45; cursor: not-allowed; }\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--accent), var(--accent2));\n  color: #fff;\n  box-shadow: 0 2px 12px var(--accent-glow);\n}\n.btn-primary:hover:not(:disabled) {\n  box-shadow: 0 4px 16px var(--accent-glow);\n  filter: brightness(1.03);\n}\n\n.btn-secondary {\n  background: var(--bg2);\n  color: var(--text2);\n  border: 1px solid var(--border2);\n}\n.btn-secondary:hover:not(:disabled) {\n  background: var(--bg3);\n  color: var(--text);\n  border-color: var(--accent);\n}\n\n.btn-danger {\n  background: transparent;\n  color: var(--red);\n  border: 1px solid rgba(220, 38, 38, 0.35);\n}\n.btn-danger:hover:not(:disabled) {\n  background: rgba(220, 38, 38, 0.06);\n  border-color: var(--red);\n}\n\n.btn-ghost {\n  background: transparent;\n  color: var(--text2);\n  border: 1px solid var(--border);\n}\n.btn-ghost:hover:not(:disabled) { background: var(--bg3); color: var(--text); }\n\n.btn-full { width: 100%; }\n.btn-sm { padding: 7px 14px; font-size: 12.5px; }\n.btn-xs { padding: 5px 12px; font-size: 12px; }\n\n/* ── Search ────────────────────────────────────── */\n.search-input {\n  background: var(--bg2);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--text);\n  font-family: 'Syne', sans-serif;\n  font-size: 13.5px;\n  padding: 9px 14px;\n  min-width: 200px;\n  flex: 1;\n  max-width: 320px;\n  outline: none;\n  transition: border-color 0.18s, box-shadow 0.18s;\n}\n.search-input::placeholder { color: var(--text3); }\n.search-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.15);\n}\n\n/* ── DB Cards ──────────────────────────────────── */\n.db-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n}\n\n.db-grid-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.db-grid-divider {\n  height: 0;\n  margin: 20px 0;\n  border: none;\n  border-top: 1px solid var(--border);\n  width: 100%;\n}\n\n.db-branch-empty-notice {\n  margin: 0 0 20px;\n  padding: 14px 18px;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  background: var(--bg3);\n  color: var(--text2);\n  font-size: 13.5px;\n  line-height: 1.5;\n}\n\n.db-branch-empty-notice p {\n  margin: 0;\n}\n\n.db-branch-empty-notice strong {\n  font-weight: 700;\n  color: var(--text);\n}\n\n/* Branch subsection (under protected cards, above droppable grid or empty notice) */\n.db-branch-section {\n  margin-bottom: 12px;\n}\n\n.db-branch-section-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text);\n  letter-spacing: -0.2px;\n  margin: 0;\n}\n\n.db-branch-empty-notice-branch-slot {\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.db-card-glass {\n  background: var(--bg2);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.db-card-glass:hover {\n  border-color: rgba(79, 70, 229, 0.35);\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);\n}\n\n.db-card-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.db-status-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 5px;\n}\n.db-status-online {\n  background: var(--green);\n  box-shadow: 0 0 0 2px rgba(5, 150, 105, 0.2);\n}\n.db-status-offline {\n  background: var(--text3);\n}\n\n.db-name {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 12.5px;\n  color: var(--text);\n  word-break: break-all;\n  font-weight: 500;\n  line-height: 1.45;\n}\n\n.db-detail-line {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 11px;\n  color: var(--text3);\n  margin-top: 4px;\n  padding-left: 18px;\n  line-height: 1.4;\n}\n\n.db-meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.db-meta-item {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: var(--text3);\n  font-size: 12px;\n}\n\n.db-state-pill {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  padding: 4px 8px;\n  border-radius: 6px;\n  background: var(--bg3);\n  color: var(--text3);\n  border: 1px solid var(--border);\n}\n.db-state-online { background: rgba(5, 150, 105, 0.1); color: var(--green); border-color: rgba(5, 150, 105, 0.25); }\n.db-state-unknown { background: rgba(217, 119, 6, 0.1); color: var(--amber); border-color: rgba(217, 119, 6, 0.25); }\n\n.db-actions {\n  display: flex;\n  gap: 8px;\n  margin-top: 6px;\n  align-items: center;\n  min-height: 32px;\n}\n\n.db-no-drop {\n  font-size: 11.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: var(--text3);\n  padding: 6px 10px;\n  border-radius: 6px;\n  background: var(--bg3);\n  border: 1px solid var(--border);\n  cursor: default;\n  user-select: none;\n}\n\n/* Protected databases strip (config reference + border before main list) */\n.protected-section {\n  margin-bottom: 28px;\n  padding-bottom: 28px;\n  border-bottom: 1px solid var(--border);\n}\n\n.protected-section h3 {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.protected-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.protected-tag {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 11.5px;\n  padding: 8px 12px;\n  background: var(--bg3);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  color: var(--text2);\n  cursor: default;\n}\n\n.protected-tag svg {\n  flex-shrink: 0;\n  opacity: 0.65;\n}\n\n/* Skeletons */\n.db-card-skeleton {\n  min-height: 160px;\n  background: var(--bg2);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 20px;\n}\n.skeleton-line {\n  background: linear-gradient(90deg, var(--bg3) 25%, var(--bg4) 50%, var(--bg3) 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.2s ease-in-out infinite;\n  border-radius: 6px;\n}\n.skeleton-title { height: 16px; width: 70%; margin-bottom: 14px; }\n.skeleton-meta { height: 12px; width: 45%; margin-bottom: 20px; }\n.skeleton-actions { height: 32px; width: 100%; opacity: 0.5; }\n@keyframes shimmer {\n  0% { background-position: 100% 0; }\n  100% { background-position: -100% 0; }\n}\n\n/* ── Modal ─────────────────────────────────────── */\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(17, 24, 39, 0.45);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n  padding: 16px;\n}\n\n.modal-glass {\n  background: var(--bg2);\n  border: 1px solid var(--border);\n  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.12);\n}\n\n.modal {\n  border-radius: var(--radius-lg);\n  padding: 28px;\n  width: 440px;\n  max-width: 100%;\n}\n\n.modal h3 {\n  font-size: 18px;\n  font-weight: 700;\n  margin-bottom: 8px;\n  letter-spacing: -0.3px;\n  color: var(--text);\n}\n\n.modal-sub {\n  color: var(--text3);\n  font-size: 13px;\n  margin-bottom: 22px;\n  line-height: 1.45;\n}\n\n.mono-inline {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 12px;\n  color: var(--accent);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 24px;\n}\n\n/* ── Forms ─────────────────────────────────────── */\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  margin-bottom: 16px;\n}\n\n.field label {\n  font-size: 11.5px;\n  font-weight: 700;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n}\n\n.field input,\n.field select {\n  background: var(--bg2);\n  border: 1px solid var(--border2);\n  border-radius: var(--radius);\n  color: var(--text);\n  font-family: 'Syne', sans-serif;\n  font-size: 14px;\n  padding: 11px 12px;\n  outline: none;\n  transition: border-color 0.18s, box-shadow 0.18s;\n}\n.field input:focus,\n.field select:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);\n}\n.field input::placeholder { color: var(--text3); }\n.field select option { background: var(--bg2); }\n\n.field-hint {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 11.5px;\n  color: var(--accent);\n}\n\n.field-hint-preview {\n  margin-top: 8px;\n  font-family: 'Syne', sans-serif;\n  font-size: 12px;\n  color: var(--text3);\n}\n\n.field-hint-preview .mono-inline {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 11.5px;\n  color: var(--accent);\n}\n\n.field-label-block {\n  display: block;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  margin-bottom: 10px;\n}\n\n.radio-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 12px;\n  cursor: pointer;\n  font-size: 13px;\n  line-height: 1.45;\n  color: var(--text2);\n}\n\n.radio-row input {\n  margin-top: 3px;\n  accent-color: var(--accent);\n  flex-shrink: 0;\n}\n\n.radio-row strong {\n  color: var(--text);\n}\n\n.field-warning {\n  font-size: 12.5px;\n  color: var(--amber);\n  margin-top: 8px;\n  line-height: 1.4;\n}\n\n.inline-code {\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 11.5px;\n  background: var(--bg3);\n  padding: 2px 6px;\n  border-radius: 4px;\n  color: var(--accent);\n}\n\n/* ── Login (light) ─────────────────────────────── */\n.login-page-hangfire {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: linear-gradient(165deg, #eef2ff 0%, var(--bg) 45%, #f8fafc 100%);\n}\n\n.login-glass {\n  border-radius: 20px;\n  border: 1px solid var(--border);\n  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.08);\n}\n\n.login-card-hangfire {\n  width: 100%;\n  max-width: 400px;\n  padding: 44px 40px;\n  background: var(--bg2);\n}\n\n.login-lock-wrap {\n  width: 56px;\n  height: 56px;\n  margin: 0 auto 20px;\n  border-radius: 14px;\n  background: linear-gradient(135deg, rgba(79, 70, 229, 0.12), rgba(79, 70, 229, 0.05));\n  border: 1px solid rgba(79, 70, 229, 0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--accent);\n}\n\n.login-title-hangfire {\n  text-align: center;\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n  margin-bottom: 8px;\n  color: var(--text);\n}\n\n.login-sub-hangfire {\n  text-align: center;\n  color: var(--text3);\n  font-size: 14px;\n  margin-bottom: 28px;\n}\n\n.login-form-hangfire {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.login-password-input {\n  width: 100%;\n  padding: 14px 16px;\n  font-size: 15px;\n  font-family: 'Syne', sans-serif;\n  border-radius: var(--radius);\n  border: 1px solid var(--border2);\n  background: var(--bg2);\n  color: var(--text);\n  outline: none;\n  transition: border-color 0.18s, box-shadow 0.18s;\n}\n.login-password-input:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);\n}\n.login-password-input::placeholder { color: var(--text3); }\n\n.btn-unlock {\n  padding: 12px;\n  font-size: 14px;\n}\n\n.error-msg-compact {\n  margin-bottom: 0;\n}\n\n.error-msg {\n  background: rgba(220, 38, 38, 0.08);\n  border: 1px solid rgba(220, 38, 38, 0.25);\n  color: var(--red);\n  border-radius: var(--radius);\n  padding: 10px 12px;\n  font-size: 13px;\n}\n\n/* ── Empty / loading ───────────────────────────── */\n.empty-state-modern {\n  padding: 56px 24px;\n  border-radius: var(--radius-lg);\n  border: 1px dashed var(--border2);\n  background: var(--bg2);\n}\n\n.empty-icon-wrap {\n  width: 72px;\n  height: 72px;\n  margin: 0 auto 16px;\n  border-radius: 16px;\n  background: rgba(79, 70, 229, 0.08);\n  border: 1px solid rgba(79, 70, 229, 0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text3);\n}\n\n.empty-title {\n  font-size: 17px;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 6px;\n}\n\n.empty-desc {\n  font-size: 13.5px;\n  color: var(--text3);\n  margin-bottom: 20px;\n  max-width: 360px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.loading-state,\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  text-align: center;\n  color: var(--text3);\n}\n\n.spinner {\n  width: 30px;\n  height: 30px;\n  border: 2px solid var(--border);\n  border-top-color: var(--accent);\n  border-radius: 50%;\n  animation: spin 0.75s linear infinite;\n}\n@keyframes spin { to { transform: rotate(360deg); } }\n\n/* ── Toast (top-right) ─────────────────────────── */\n.toast {\n  position: fixed;\n  top: 24px;\n  right: 24px;\n  bottom: auto;\n  left: auto;\n  padding: 14px 20px;\n  border-radius: var(--radius);\n  font-size: 13.5px;\n  font-weight: 600;\n  z-index: 200;\n  animation: toastIn 0.25s ease;\n  max-width: min(420px, calc(100vw - 32px));\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n}\n.toast-success {\n  background: var(--bg2);\n  border: 1px solid rgba(5, 150, 105, 0.4);\n  color: var(--green);\n}\n.toast-error {\n  background: var(--bg2);\n  border: 1px solid rgba(220, 38, 38, 0.35);\n  color: var(--red);\n}\n\n@keyframes toastIn {\n  from { transform: translateY(-10px); opacity: 0; }\n  to { transform: translateY(0); opacity: 1; }\n}\n\n/* ── Logs page ─────────────────────────────────── */\n.page-logs .logs-toolbar {\n  flex-wrap: wrap;\n  gap: 10px;\n  align-items: flex-end;\n}\n\n.logs-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.logs-field-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: var(--text3);\n}\n\n.logs-field input[type=\"date\"],\n.logs-field select {\n  font-family: inherit;\n  font-size: 13px;\n  padding: 8px 10px;\n  border-radius: var(--radius);\n  border: 1px solid var(--border2);\n  background: var(--bg2);\n  color: var(--text);\n}\n\n.logs-checkbox {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 4px;\n}\n\n.logs-checkbox span {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text2);\n}\n\n.logs-error {\n  margin-bottom: 16px;\n  padding: 12px 16px;\n  border-radius: var(--radius);\n  background: rgba(220, 38, 38, 0.08);\n  border: 1px solid rgba(220, 38, 38, 0.25);\n  color: var(--red);\n  font-size: 13px;\n}\n\n.log-viewer {\n  background: var(--bg2);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px;\n  max-height: min(70vh, 720px);\n  overflow: auto;\n  font-family: 'JetBrains Mono', monospace;\n  font-size: 11.5px;\n  line-height: 1.45;\n}\n\n.log-line {\n  margin: 0 0 6px;\n  white-space: pre-wrap;\n  word-break: break-word;\n  color: var(--text2);\n}\n\n.log-line:last-child {\n  margin-bottom: 0;\n}\n\n.log-level-error {\n  color: var(--red);\n}\n\n.log-level-warn {\n  color: var(--amber);\n}\n\n.log-level-info,\n.log-level-http {\n  color: var(--text2);\n}\n\n.logs-loading,\n.logs-empty {\n  color: var(--text3);\n  font-size: 13px;\n  padding: 8px 0;\n}\n\n/* ── Mobile ───────────────────────────────────── */\n@media (max-width: 640px) {\n  .topnav {\n    padding: 12px 16px;\n  }\n\n  .topnav-nav {\n    order: 3;\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .page {\n    padding: 16px 16px 32px;\n  }\n\n  .page-header {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .header-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .search-input {\n    max-width: none;\n    width: 100%;\n  }\n\n  .db-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .toast {\n    top: 16px;\n    left: 16px;\n    right: 16px;\n    bottom: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
